module.exports = __webpack_public_path__ + "static/media/hamburgerBtn.f88011a8.svg";